import { ImageIcon } from "lucide-react";

import type { ImageComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const ImageComponentListItem = ({ mod }: { mod: ImageComponent }) => {
  const subtitle =
    mod.description || (mod.src ? mod.src.split("/").pop() : "No image set");
  return (
    <ModificationListItem
      mod={mod}
      icon={<ImageIcon size={16} />}
      title="Image component"
      subtitle={subtitle ?? ""}
    />
  );
};
